/* MX V2 — PDP rebuild layer (browser-verified final):
   images LEFT sticky / buy column RIGHT; tidy price box; equal-width qty pills;
   V2 upload button; share buttons removed; legacy WhatsApp removed;
   dynamic price + compare-at + save badge + Tabby per variant;
   v2.1: header Track-Order chip; v2.2: bigger category press plates;
   v2.3: WhatsApp CTA card inside every mega menu;
   v2.3.1: killed legacy z-index:99999 on .nDesign/.cOrder;
   v2.4: all static CSS lives in assets/redesign.css (first-paint layout);
   v2.6: categories free-scroll; v2.6.1: 520px category images;
   v2.7: conversion layer; v2.10: payment methods — Tabby & Tamara badge
   plus all-ways-to-pay (Amex / crypto / bank / cash).
   v2.12: MULTI-OPTION support — pills = option1, extra selects (e.g. Lids)
   now resolve the correct variant together; price/pills refresh on change. */
(function () {
  var MXAR = (document.documentElement.lang || '').slice(0,2) === 'ar' || document.documentElement.dir === 'rtl';
  var MXT = MXAR ? {
    track: 'تتبّع طلبك',
    vat: ' <b>(شامل الضريبة)</b>',
    t1b: 'تسليم سريع', t1s: '5 أيام عمل بعد اعتماد التصميم',
    t2b: 'قسّطها على 4 — تابي وتمارا', t2s: 'بدون أي فوائد',
    t3b: 'كل طرق الدفع', t3s: 'بطاقات · أمكس · كريبتو · تحويل بنكي · كاش',
    t4b: 'بروفة قبل الطباعة', t4s: 'ما منطبع إلا بعد موافقتك',
    bulkB: 'بدك كمية أكبر؟', bulkS: 'خد سعر جملة خاص على واتساب — رد سريع', bulkBtn: 'واتساب ←',
    bulkMsg: 'مرحبا ماكس برنت! بدي تسعيرة لكمية أكبر من: ',
    megaB: 'ما لقيت يلي بدك؟',
    megaP: 'منطبع كل شي تقريباً. ابعتلنا شو بدك — خبير طباعة حقيقي بيرد خلال دقائق.',
    megaA: 'راسلنا على واتساب ←',
    megaMsg: 'مرحبا ماكس برنت! بدور على شي مخصص.'
  } : {
    track: 'Track Order',
    vat: ' <b>(Inclusive of VAT)</b>',
    t1b: 'Fast delivery', t1s: '5 business days after artwork approval',
    t2b: 'Pay in 4 — Tabby &amp; Tamara', t2s: '0% interest instalments',
    t3b: 'All ways to pay', t3s: 'Cards · Amex · Crypto · Bank · Cash',
    t4b: 'Proof before print', t4s: 'We only print after your OK',
    bulkB: 'Need a bigger quantity?', bulkS: 'Get a custom bulk price on WhatsApp — fast reply', bulkBtn: 'WhatsApp \u2192',
    bulkMsg: 'Hello MaxPrint! I need a quote for a larger quantity of: ',
    megaB: 'Can\u2019t find it?',
    megaP: 'We print almost anything. Send us what you need — a real print expert replies in minutes.',
    megaA: 'WhatsApp us \u2192',
    megaMsg: 'Hello MaxPrint! I\u0027m looking for something custom.'
  };
  function init() {
    /* ---------- v2.6: drag-to-scroll categories ---------- */
    try {
      var cvp = document.querySelector('.collection-list .flickity-viewport');
      if (cvp) {
        var down = false, moved = 0, lastX = 0, vel = 0, mom = null;
        cvp.addEventListener('mousedown', function (e) {
          down = true; moved = 0; lastX = e.clientX; vel = 0;
          if (mom) cancelAnimationFrame(mom);
          cvp.style.cursor = 'grabbing';
          e.preventDefault();
        });
        window.addEventListener('mousemove', function (e) {
          if (!down) return;
          var dx = e.clientX - lastX; lastX = e.clientX;
          moved += Math.abs(dx);
          cvp.scrollLeft -= dx; vel = dx;
        });
        window.addEventListener('mouseup', function () {
          if (!down) return;
          down = false; cvp.style.cursor = 'grab';
          (function decay() {
            if (Math.abs(vel) < .5) return;
            cvp.scrollLeft -= vel; vel *= .94;
            mom = requestAnimationFrame(decay);
          })();
        });
        cvp.addEventListener('click', function (e) {
          if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; }
        }, true);
        var btns = document.querySelectorAll('.collection-list .flickity-prev-next-button');
        Array.prototype.forEach.call(btns, function (b) {
          var nb = b.cloneNode(true);
          nb.removeAttribute('disabled');
          b.parentNode.replaceChild(nb, b);
          nb.addEventListener('click', function (ev) {
            ev.preventDefault(); ev.stopPropagation();
            var d = nb.classList.contains('previous') ? -1 : 1;
            cvp.scrollBy({ left: d * cvp.clientWidth * 0.8, behavior: 'smooth' });
          });
        });
      }
    } catch (e) {}

    /* ---------- v2.6.1: sharper category plate images ---------- */
    try {
      var cimgs = document.querySelectorAll('.collection-item img');
      Array.prototype.forEach.call(cimgs, function (im) {
        ['src', 'srcset', 'data-src', 'data-srcset'].forEach(function (attr) {
          var v = im.getAttribute(attr);
          if (v && /width=\d+/.test(v)) {
            im.setAttribute(attr, v.replace(/width=\d+/g, 'width=520').replace(/height=\d+/g, 'height=520'));
          }
        });
        if (im.getAttribute('sizes')) im.setAttribute('sizes', '260px');
      });
    } catch (e) {}

    /* ---------- header Track-Order chip (all pages) ---------- */
    try {
      if (!document.querySelector('.mx-track-chip')) {
        var acct = document.querySelector('.header__action-item--account');
        if (acct) {
          var chip = document.createElement('a');
          chip.className = 'mx-track-chip';
          chip.href = '/tools/track-your-order';
          chip.textContent = MXT.track;
          acct.parentNode.insertBefore(chip, acct);
        }
      }
    } catch (e) {}

    /* ---------- v2.3: WhatsApp CTA card in every mega menu ---------- */
    try {
      var inners = document.querySelectorAll('.mega-menu .mega-menu__inner');
      Array.prototype.forEach.call(inners, function (inner) {
        if (inner.querySelector('.mx-mega-cta')) return;
        var card = document.createElement('div');
        card.className = 'mega-menu__column mx-mega-cta';
        card.innerHTML =
          '<b>' + MXT.megaB + '</b>' +
          '<p>' + MXT.megaP + '</p>' +
          '<a href="https://wa.me/971522100909?text=' + encodeURIComponent(MXT.megaMsg) + '" target="_blank" rel="noopener">' + MXT.megaA + '</a>';
        inner.appendChild(card);
      });
    } catch (e) {}

    /* ---------- layout DOM fixes (all product pages) ---------- */
    var wrap0 = document.querySelector('.product-block-list__wrapper');
    if (wrap0) { wrap0.style.minHeight = '0'; }
    var desc = document.querySelector('.product-block-list__item--description');
    var formDiv = document.querySelector('form.product-form > div');
    if (desc && formDiv) { formDiv.appendChild(desc); }

    /* ---------- v2.7/v2.10: trust badges + bulk WhatsApp quote (all PDPs) ---------- */
    try {
      var pay = document.querySelector('.product-form__payment-container');
      if (pay && !document.querySelector('.mx-trust')) {
        var t = document.createElement('div');
        t.className = 'mx-trust';
        t.innerHTML =
          '<div><i>✓</i><div><b>' + MXT.t1b + '</b><span>' + MXT.t1s + '</span></div></div>' +
          '<div><i>✓</i><div><b>' + MXT.t2b + '</b><span>' + MXT.t2s + '</span></div></div>' +
          '<div><i>✓</i><div><b>' + MXT.t3b + '</b><span>' + MXT.t3s + '</span></div></div>' +
          '<div><i>✓</i><div><b>' + MXT.t4b + '</b><span>' + MXT.t4s + '</span></div></div>';
        pay.parentNode.insertBefore(t, pay.nextSibling);

        var ttlEl = document.querySelector('.product-meta__title');
        var ttl = ttlEl ? ttlEl.textContent.trim() : 'a product';
        var wa = document.createElement('a');
        wa.className = 'mx-bulk-wa';
        wa.target = '_blank'; wa.rel = 'noopener';
        wa.href = 'https://wa.me/971522100909?text=' + encodeURIComponent(MXT.bulkMsg + ttl + ' — ' + location.origin + location.pathname);
        wa.innerHTML =
          '<span class="mx-bwa-t"><b>' + MXT.bulkB + '</b><span>' + MXT.bulkS + '</span></span>' +
          '<span class="mx-bwa-btn">' + MXT.bulkBtn + '</span>';
        t.parentNode.insertBefore(wa, t.nextSibling);
      }
    } catch (e) {}

    /* ---------- option controls: selects AND colour-swatch radios, by option position ---------- */
    function mxPosOf(el, fallbackIdx) {
      var p = el.getAttribute && el.getAttribute('data-option-position');
      if (p) { return parseInt(p, 10); }
      var m = String(el.name || '').match(/-(\d+)$/);
      if (m) { return parseInt(m[1], 10); }
      return fallbackIdx;
    }

    var mxSlots = [];
    Array.prototype.forEach.call(document.querySelectorAll('.product-form__single-selector'), function (n, i) {
      var pos = mxPosOf(n, i + 1);
      if (!pos || pos < 1) { return; }
      if (n.tagName === 'SELECT') {
        mxSlots[pos - 1] = { type: 'select', el: n, pos: pos };
      } else if (n.type === 'radio') {
        var slot = mxSlots[pos - 1];
        if (!slot || slot.type !== 'radio') { slot = { type: 'radio', els: [], pos: pos }; mxSlots[pos - 1] = slot; }
        slot.els.push(n);
      }
    });
    var mxCtrls = mxSlots.filter(function (c) { return !!c; });
    if (!mxCtrls.length) { return; }
    mxCtrls.forEach(function (c, i) { c.idx = i; });

    function mxValues(c) {
      if (!c) { return []; }
      return c.type === 'select'
        ? Array.prototype.map.call(c.el.options, function (o) { return o.value; })
        : c.els.map(function (r) { return r.value; });
    }
    function mxGet(c) {
      if (!c) { return null; }
      if (c.type === 'select') { return c.el.value; }
      for (var i = 0; i < c.els.length; i++) { if (c.els[i].checked) { return c.els[i].value; } }
      return null;
    }
    function mxSet(c, val) {
      if (!c) { return; }
      if (c.type === 'select') { c.el.value = val; }
      else { c.els.forEach(function (r) { r.checked = (r.value === val); }); }
    }
    function mxOn(c, cb) {
      if (!c) { return; }
      if (c.type === 'select') { c.el.addEventListener('change', cb); }
      else { c.els.forEach(function (r) { r.addEventListener('change', cb); }); }
    }
    function mxNodeOf(c) { return c.type === 'select' ? c.el : c.els[0]; }
    function mxIsQtyCtrl(c) {
      var vals = mxValues(c);
      if (!vals.length) { return false; }
      return /\d[\d,]*\s*(pcs|pieces)\b/i.test(vals[0]) || /\d[\d,]*\s*قطعة/.test(vals[0]);
    }

    /* the control we turn into pills: the quantity one, else the first dropdown */
    var pillCtrl = null;
    for (var ci = 0; ci < mxCtrls.length; ci++) { if (mxIsQtyCtrl(mxCtrls[ci])) { pillCtrl = mxCtrls[ci]; break; } }
    if (!pillCtrl) {
      for (var cj = 0; cj < mxCtrls.length; cj++) { if (mxCtrls[cj].type === 'select') { pillCtrl = mxCtrls[cj]; break; } }
    }
    if (pillCtrl && mxValues(pillCtrl).length < 2) { pillCtrl = null; }

    var opt = pillCtrl ? mxNodeOf(pillCtrl).closest('.product-form__option') : null;
    var block = document.querySelector('.product-info__block-item--variant-selector');
    var payTarget = document.querySelector('.product-form__payment-container') || document.querySelector('.product-form__add-button');
    var anchor = payTarget ? (payTarget.closest('form') || payTarget) : null;
    if (anchor && block) { anchor.parentNode.insertBefore(block, anchor); }

    /* nicer label — ONLY when that option really is a quantity option */
    var optName = opt ? opt.querySelector('.product-form__option-name') : null;
    if (pillCtrl && mxIsQtyCtrl(pillCtrl) && optName && optName.childNodes.length && optName.childNodes[0].nodeType === 3) {
      optName.childNodes[0].textContent = MXAR ? 'الكمية (قطعة): ' : 'Quantity (pcs): ';
    }

    var handle = location.pathname.split('/products/')[1];
    if (!handle) { return; }
    handle = handle.split('?')[0].split('/')[0];

    /* localized product JSON — on /ar/ the option values come back translated,
       which is what the rendered selects/radios actually contain */
    var mxRoot = '/';
    try { if (window.Shopify && Shopify.routes && Shopify.routes.root) { mxRoot = Shopify.routes.root; } } catch (e) {}
    if (mxRoot.charAt(mxRoot.length - 1) !== '/') { mxRoot += '/'; }

    fetch(mxRoot + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (pj) {
        function findVariant(opts) {
          for (var i = 0; i < pj.variants.length; i++) {
            var v = pj.variants[i], ok = true;
            for (var j = 0; j < opts.length; j++) {
              if (opts[j] != null && v['option' + (j + 1)] !== opts[j]) { ok = false; break; }
            }
            if (ok) { return v; }
          }
          return null;
        }
        function currentOpts() { return mxCtrls.map(function (c) { return mxGet(c); }); }
        function variantForPill(name) {
          var o = currentOpts();
          if (pillCtrl && name != null) { o[pillCtrl.idx] = name; }
          return findVariant(o) || ((mxCtrls.length === 1 && name != null) ? findVariant([name]) : null);
        }

        var form = document.querySelector('form.product-form');
        var idInput = form ? form.querySelector('input[name="id"]') : null;
        if (form && !idInput) {
          idInput = document.createElement('input');
          idInput.type = 'hidden';
          idInput.name = 'id';
          form.appendChild(idInput);
        }

        function fmt(cents) { return (cents / 100).toLocaleString('en-US'); }

        function replaceDigits(root, str) {
          var done = false;
          (function walk(n) {
            if (done || !n) { return; }
            for (var i = 0; i < n.childNodes.length; i++) {
              var c = n.childNodes[i];
              if (c.nodeType === 3 && /\d/.test(c.textContent)) {
                c.textContent = c.textContent.replace(/[\d.,]+/, str);
                done = true;
                return;
              }
              if (c.nodeType === 1) { walk(c); if (done) { return; } }
            }
          })(root);
        }

        var cmpEl = document.querySelector('.product-form__info-list .price--compare');
        var badgeEl = document.querySelector('.product-meta__label-list .product-label--on-sale');

        function apply(name) {
          var v = variantForPill(name);
          if (!v) { return; }
          if (idInput) { idInput.value = v.id; }
          var p = document.querySelector('.price.CurrencyWordInfo');
          if (p) {
            var s = p.querySelector('.CurrencyWords');
            var sh = s ? s.outerHTML : '';
            p.innerHTML = sh + ' ' + fmt(v.price) + MXT.vat;
          }
          if (v.compare_at_price && v.compare_at_price > v.price) {
            if (cmpEl) { cmpEl.style.display = ''; replaceDigits(cmpEl, fmt(v.compare_at_price)); }
            if (badgeEl) { badgeEl.style.display = ''; replaceDigits(badgeEl, fmt(v.compare_at_price - v.price)); }
          } else {
            if (cmpEl) { cmpEl.style.display = 'none'; }
            if (badgeEl) { badgeEl.style.display = 'none'; }
          }
          var lbl = opt ? opt.querySelector('.product-form__selected-value') : null;
          if (lbl && name != null) { lbl.textContent = name; }
          if (window.mxTabbyUpdate) { try { window.mxTabbyUpdate(v.price); } catch (e) {} }
          try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (e) {}
        }
        function applyCurrent() { apply(pillCtrl ? mxGet(pillCtrl) : null); }

        /* per-piece pricing on the pills + BEST VALUE on the cheapest unit */
        var symEl = document.querySelector('.CurrencyWords');
        var sym = symEl ? symEl.textContent.trim() : 'AED';
        function qtyOf(name) { var m = String(name).match(/\d[\d,]*/); return m ? parseInt(m[0].replace(/,/g, ''), 10) : 0; }
        var mxPillIsQty = !!pillCtrl && mxIsQtyCtrl(pillCtrl);
        function unitOf(name) {
          if (!mxPillIsQty) { return Infinity; }
          var v = variantForPill(name), q = qtyOf(name);
          return (v && q > 0) ? v.price / q : Infinity;
        }

        var wrap = null;
        function refreshPills() {
          if (!pillCtrl || !wrap) { return; }
          var vals = mxValues(pillCtrl);
          var cur = mxGet(pillCtrl);
          var bestName = null, bestUnit = Infinity;
          vals.forEach(function (val) {
            var u = unitOf(val);
            if (u < bestUnit) { bestUnit = u; bestName = val; }
          });
          Array.prototype.forEach.call(wrap.querySelectorAll('.mx-tier'), function (b) {
            var val = b.getAttribute('data-mx-value');
            var u = unitOf(val);
            var uEl = b.querySelector('.mx-tu');
            if (uEl && isFinite(u) && u > 0) {
              var ua = u / 100;
              uEl.textContent = sym + ' ' + (ua < 0.095 ? ua.toFixed(3) : ua.toFixed(2)) + (MXAR ? ' /قطعة' : ' /pc');
            }
            b.classList.toggle('mx-best', val === bestName && vals.length >= 3 && isFinite(bestUnit));
            b.classList.toggle('on', val === cur);
          });
        }

        if (pillCtrl) {
          wrap = document.createElement('div');
          wrap.className = 'mx-tiers';
          var curVal = mxGet(pillCtrl);
          mxValues(pillCtrl).forEach(function (val) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'mx-tier' + (val === curVal ? ' on' : '');
            b.innerHTML = '<span class="mx-tq">' + val.replace(/\s*(pcs|pieces|قطعة)\s*$/i, '') + '</span><span class="mx-tu"></span>';
            b.setAttribute('data-mx-value', val);
            b.addEventListener('click', function () {
              mxSet(pillCtrl, val);
              try { mxNodeOf(pillCtrl).dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
              apply(val);
              refreshPills();
            });
            wrap.appendChild(b);
          });
          var sw = opt ? opt.querySelector('.select-wrapper') : null;
          if (sw) {
            sw.style.display = 'none';
            sw.parentNode.insertBefore(wrap, sw);
          } else if (opt) {
            opt.appendChild(wrap);
          }
        }

        /* every other option control re-resolves the variant */
        mxCtrls.forEach(function (c) {
          if (c === pillCtrl) { return; }
          mxOn(c, function () {
            applyCurrent();
            refreshPills();
            var node = mxNodeOf(c);
            var sOpt = node.closest('.product-form__option');
            var sLbl = sOpt ? sOpt.querySelector('.product-form__selected-value') : null;
            var val = mxGet(c);
            if (sLbl && val != null) { sLbl.textContent = val; }
          });
        });

        var urlVariant = new URLSearchParams(location.search).get('variant');
        if (urlVariant) {
          pj.variants.forEach(function (v) {
            if (String(v.id) === String(urlVariant)) {
              mxCtrls.forEach(function (c, idx) {
                var val = v['option' + (idx + 1)];
                if (val != null) { mxSet(c, val); }
              });
            }
          });
        }
        applyCurrent();
        refreshPills();
      })
      .catch(function () { /* fail silent */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
